import { Modal, Button, Text, Flex } from "dash-ui";
import { useTranslation } from "react-i18next";
import { ResetConfirmationModalProps } from "./CmsSettingsContent.types";

const ResetConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
}: ResetConfirmationModalProps) => {
  const { t } = useTranslation(["common", "pages"]);
  const { t: tSettings } = useTranslation("pages", {
    keyPrefix: "cmsSettingsPage",
  });

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      title={tSettings("resetConfirmationTitle") as string}
    >
      <Flex mt={4}>
        <Text>{tSettings("resetConfirmationMessage")}</Text>
      </Flex>
      <Flex gap={10} mt={8} justifyContent="flex-start">
        <Button variation="outline" onClick={onClose} disabled={isLoading}>
          {t("common:labels.cancel")}
        </Button>
        <Button
          variation="primary"
          onClick={onConfirm}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {tSettings("confirm")}
        </Button>
      </Flex>
    </Modal>
  );
};

export default ResetConfirmationModal;
